
export var config = {
  "secret": "lasGalletasVerdesSonParaLosHumanos",
  "StripeService":"https://auxapi.srvpls.com/stripe_in/",
 // "StripeService":"http://localhost:3000/stripe_in/",
  "CacheService":"http://localhost/CacheServiceAPI"
};



// WEBPACK FOOTER //
// ./src/app/config/str.ts